export default "__VITE_ASSET__DMW51X_I__"